<template>
  <div class="data-pages dataList collectRank">
    <div class="page-head">
      <div class="ptb16">汇总排行</div>
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs mb10 br10">
            <div class="titles">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>业绩汇总</i></p>
              <v-date @time="change" class="ml10"></v-date>
            </div>
            <el-row class="rows plr16">
              <el-col class="cols" :span="4" v-for="(item,index) in amount" :key="index">
                <p class="van-text">{{ item.itemName }}</p>
                <p class="van-label">{{ item.itemValue }}</p>
              </el-col>
            </el-row>
          </div>
          <div class="boxs br10">
            <div class="align-items pr16"  @click="lookList">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>店员业绩排行</i></p>
              <p><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plrb16 el-table-class" v-if="listFlag">
              <el-table :data="list" :max-height="height - 638" :row-class-name="tableRowClassName" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="staffName" label="姓名"></el-table-column>
                <el-table-column prop="commissionTargetAmount" label="提成目标"></el-table-column>
                <el-table-column prop="deductTotalAmount" label="提成社保合计"></el-table-column>
                <el-table-column prop="commissionTargetAmountCompleteness" label="完成度"></el-table-column>
                <el-table-column prop="workAmount" label="劳动业绩"></el-table-column>
                <el-table-column prop="saleAmount" label="销售业绩"></el-table-column>
                <el-table-column prop="workingDayTotal" label="出勤"></el-table-column>
                <el-table-column prop="orderTotal" label="订单数"></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="boxs br10 mt10">
            <div class="align-items pr16" @click="formList">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>门店打卡情况</i></p>
              <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <el-row class="rows plr16" v-if="formFlag">
              <el-col class="cols" :span="4">
                <p class="van-text">在职人数</p>
                <p class="van-label">{{ form.workCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">正常出勤</p>
                <p class="van-label">{{ form.normalAttendanceCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">请假人数</p>
                <p class="van-label">{{ form.leaveCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">公休人数</p>
                <p class="van-label">{{ form.publicLeaveCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">年假人数</p>
                <p class="van-label">{{ form.yearLeaveCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">旷工人数</p>
                <p class="van-label">{{ form.noAttendanceCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">迟到人数</p>
                <p class="van-label">{{ form.overtimeCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">早退人数</p>
                <p class="van-label">{{ form.leaveEarlyCount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">缺卡人数</p>
                <p class="van-label">{{ form.absenceCount }}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      amount: [],
      list: [],
      downloadUrl: require("../../../assets/images/home/download.png"),
      dataUrl: require("../../../assets/images/home/data.png"),
      // url: this.$url.orderAchievement.groupByStaff,
      query: {
        beginTime: new Date(),
        endTime: new Date()
      },
      form: {},
      height: this.$store.getters.MainHeight,
      listFlag: false,
      formFlag: false
    };
  },

  created() {
    // this.init();
  },
  beforeDestroy() {
    if (this.$route.meta.title != "订单明细") {
      sessionStorage.removeItem("beginTime");
      sessionStorage.removeItem("endTime");
    }
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.start = 1;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.listFlag = false;
      this.formFlag = false;
      this.init();
    },
    init(val) {
      this.$api.post(this.$url.report.summary, {
        beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        if (res) {
          console.log(this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag);
          if(this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag){
              this.amount = res.filter(item =>{
              return  item.itemName!=='免脚个数' && item.itemName!=='免脚业绩' && item.itemName!=='修脚技师数'
              })
            }else{
              this.amount = res.filter(item =>{
              return  item.itemName!=='修脚技师数' && item.itemName!=='人均修脚数' && item.itemName!=='店日均技师数'
              })
            }
        }
      });
    },
    lookList () {
      this.listFlag = !this.listFlag;
      if (this.listFlag) {
        this.pageDetailByShop();
      }
    },
    pageDetailByShop() {
      this.$api.post(this.$url.orderAchievement.groupByStaff, this.query).then(res => {
        this.list = res;
      })
      .catch(error => {
        this.error = true;
      });
    },
    tableRowClassName({ row, rowIndex }) {
			if (((row.deductTotalAmount / row.commissionTargetAmount) * 100).toFixed(2) >= 100) {
				return 'success-row'
			} else if (((row.deductTotalAmount / row.commissionTargetAmount) * 100).toFixed(2) > 0) {
        return 'danger-row'
      }
			return ''
		},
    formList () {
      this.formFlag = !this.formFlag;
      if (this.formFlag) {
        this.getShopChecking();
      }
    },
    getShopChecking () {
      this.$api.post(this.$url.attendance.getShopStatistics, this.query)
      .then(res => {
        if (res) {
          this.form = res;
        }
        });
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 100%;
}
.collectRank {
  height: calc(100vh - 70px);
}
.mains-content {
  height: calc(100% - 72px);
}
.boxs {
  background: #fff;
  .titles {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
.el-table-class ::v-deep .success-row {
	color: #67c23a !important;
}
.el-table-class ::v-deep .danger-row {
	color: rgba(198, 35, 28) !important;
}
</style>